"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditRangeInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _mocks = require("../../mocks");

var _FormattedValue = require("./FormattedValue");

var _useCreditRangeInput = require("./useCreditRangeInput");

var _CreditRangeInput = require("./CreditRangeInput.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  initialValue: _propTypes.number,
  onChange: _propTypes.func
} : {};

var CreditRangeInput = function CreditRangeInput(_ref) {
  var initialValue = _ref.initialValue,
      onChange = _ref.onChange;

  var _ref2 = (0, _useCreditRangeInput.useCreditRangeInput)({
    initialValue: initialValue,
    onChange: onChange
  }),
      sliderPosition = _ref2.sliderPosition,
      sliderProgress = _ref2.sliderProgress,
      description = _ref2.description,
      onSliderChange = _ref2.onSliderChange,
      onSliderBlur = _ref2.onSliderBlur,
      getCreditValue = _ref2.getCreditValue;

  var creditValue = (0, _react.useMemo)(function () {
    return getCreditValue(sliderPosition);
  }, [sliderPosition]);
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_CreditRangeInput.SliderProgress, {
    progress: sliderProgress
  }), (0, _core.jsx)(_CreditRangeInput.Container, null, (0, _core.jsx)(_FormattedValue.FormattedValue, {
    "data-testid": "formatted-value"
  }, creditValue), (0, _core.jsx)(_CreditRangeInput.Description, {
    "data-testid": "description"
  }, description), (0, _core.jsx)(_CreditRangeInput.InputSlider, {
    "data-testid": "credit-range",
    max: _mocks.SliderRangeValues.length - 1,
    step: 0.1,
    value: sliderPosition,
    onChange: onSliderChange,
    onBlur: onSliderBlur
  })));
};

exports.CreditRangeInput = CreditRangeInput;
process.env.NODE_ENV !== "production" ? CreditRangeInput.propTypes = propTypes : void 0;
CreditRangeInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CreditRangeInput",
  "props": {
    "initialValue": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};